import { Button, Typography } from "~/common/mui";
import { useTranslation } from "react-i18next";

import { InformationPage } from "../../../../common/components/informationPage/InformationPage";
import { URL_CONTACT_US } from "../../../../utils/url/staticUrls";
import { IMG_NO_RESULTS_OR_MATCHES } from "../../../../utils/url/staticResources";

interface Props {
  mode?: "full" | "short";
  variant?: "search" | "filter";
  onClearAll?: () => void;
}

export const NoSearchResults = ({ mode = "full", variant = "search", onClearAll }: Props) => {
  const { t } = useTranslation();

  const isMatches = variant === "filter";

  return (
    <InformationPage.CenterContents className={"scha__search__no-results"}>
      <Typography variant="headlineLarge">
        {t(isMatches ? "noMatchesFound.header" : "noResultsFound.header")}
      </Typography>
      <InformationPage.Subtitle className="f-pre-line">
        {t(isMatches ? "noMatchesFound.text" : "noResultsFound.text")}
      </InformationPage.Subtitle>
      <InformationPage.Image src={IMG_NO_RESULTS_OR_MATCHES} alt={""} />
      {mode === "full" && (
        <>
          <Button className={"mt-20"} href={URL_CONTACT_US}>
            {t("notFoundContactUs.contact")}
          </Button>
          {isMatches && (
            <Button variant={"text"} onClick={onClearAll}>
              {t("noMatchesFound.reset.filters.btn")}
            </Button>
          )}
        </>
      )}
    </InformationPage.CenterContents>
  );
};
